enum CarrierFormSteps {
    info = 0,
    review = 1,
}

export default CarrierFormSteps;
